// logo_carousel_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["logoList"]

  connect() {
    this.cloneLogos()
    this.setupHoverPause()
    // Wait for cloning to complete before calculating and starting the animation
    setTimeout(() => this.createAndStartAnimation(), 0)
  }

  cloneLogos() {
    // Clone the list for infinite scrolling
    const logoList = this.logoListTarget
    const logoItems = Array.from(logoList.querySelectorAll('li'))

    // Clone each logo and append to create a seamless loop
    logoItems.forEach(item => {
      const clone = item.cloneNode(true)
      logoList.appendChild(clone)
    })

    // Add a second set of clones to ensure continuous movement
    logoItems.forEach(item => {
      const clone = item.cloneNode(true)
      logoList.appendChild(clone)
    })
  }

  setupHoverPause() {
    // Pause animation on hover
    this.logoListTarget.addEventListener('mouseenter', () => {
      this.logoListTarget.style.animationPlayState = 'paused'
    })

    this.logoListTarget.addEventListener('mouseleave', () => {
      this.logoListTarget.style.animationPlayState = 'running'
    })
  }

  createAndStartAnimation() {
    // Create the keyframes for the animation
    this.createKeyframesStyle()

    // Apply the animation directly to the element
    const logoList = this.logoListTarget

    // Get the original width for perfect looping
    const originalWidth = this.getOriginalWidth()

    // The animation needs to move exactly the width of the original content
    // for a perfect loop when using the cloned content technique
    logoList.style.animation = `scroll ${10 * (originalWidth / 500)}s linear infinite`
  }

  getOriginalWidth() {
    // Get all logo items
    const items = this.logoListTarget.querySelectorAll('li')
    const count = items.length / 2 // Half are original, half are clones

    // Calculate the width of just the original items (before cloning)
    let originalWidth = 0
    for (let i = 0; i < count; i++) {
      // Include the width and the gap (space-x-12 = 3rem = 48px)
      originalWidth += items[i].offsetWidth + (i < count - 1 ? 48 : 0)
    }

    return originalWidth
  }

  createKeyframesStyle() {
    // Check if the keyframes style already exists
    if (!document.getElementById('logo-carousel-keyframes')) {
      // Create a style element
      const styleElement = document.createElement('style')
      styleElement.id = 'logo-carousel-keyframes'

      // Define the keyframes
      // The animation needs to move exactly the width of the original content
      const keyframes = `
        @keyframes scroll {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(-33.333%);  /* Move by exactly 1/3 since we have 3 sets */
          }
        }
      `

      // Add the keyframes to the style element
      styleElement.textContent = keyframes

      // Append the style element to the document head
      document.head.appendChild(styleElement)
    }
  }
}
